var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBroadcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2234 19.9936C3.52336 19.9936 3.82008 19.9516 4.11036 19.871L5.57786 19.4517C5.78106 19.3936 5.98425 19.3646 6.18422 19.3646C6.39386 19.3646 6.59705 19.3969 6.79057 19.4646C8.11939 19.9226 9.55142 20.0871 10.9544 19.9516C15.7569 19.4936 19.6304 15.5233 19.9723 10.7176C20.2174 7.2698 18.7499 4.07354 15.9504 1.95452C14.2861 0.693437 12.1736 0 9.99973 0C9.75783 0 9.51594 0.00967583 9.28049 0.0258023C4.47481 0.364457 0.507713 4.24125 0.0464967 9.04048C-0.0889653 10.4403 0.0722994 11.8304 0.520614 13.1656C0.656076 13.5656 0.672203 13.9687 0.565768 14.3332L0.143256 15.8168C-0.111542 16.707 -0.00510749 17.6488 0.439982 18.4003C1.02053 19.3872 2.0881 20 3.22663 20L3.2234 19.9936ZM1.97199 9.22432C2.3429 5.35398 5.54239 2.22867 9.41595 1.95452C9.60625 1.94162 9.80299 1.93517 9.99973 1.93517C11.7543 1.93517 13.454 2.48992 14.7828 3.49621C17.0502 5.21529 18.2371 7.79552 18.0404 10.5822C17.7662 14.4557 14.6409 17.6552 10.7706 18.0261C10.5093 18.0519 10.2513 18.0616 9.99328 18.0616C9.11278 18.0616 8.2484 17.9197 7.4195 17.6326C6.67446 17.3778 5.85201 17.3617 5.04892 17.5907L3.58141 18.01C3.01699 18.1713 2.41063 17.9261 2.10746 17.4133C1.93329 17.1198 1.89781 16.7296 2.00425 16.3458L2.42676 14.8621C2.63963 14.1203 2.61382 13.3172 2.3558 12.5464C1.99457 11.4691 1.86556 10.3532 1.97199 9.22432Z",
    fill: "#292D32"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 10,
    r: 1,
    fill: "#292D32"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 1,
    fill: "#292D32"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 1,
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.1bcc43e40fc3b0359cd7ed208b2180ad.svg";
export { ForwardRef as ReactComponent };